import logo from './logo.svg';
import './css/App.css';
import "./css/designSystem/Navbar.css";
import ScrollToTop from './frontend/components/ScrollToTop';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from './frontend/pages/HomePage';
import Navbar from "./frontend/designSystem/Navbar";
import Footer from './frontend/designSystem/Footer';
import ContactUs from './frontend/components/ContactUs';
import MortgagePage from './frontend/pages/Mortgage';
import BusinessProtectionPage from './frontend/pages/BusinessProtection';
import RelevantLifePlanPage from './frontend/pages/RelevantLifePlan';
import LifeInsuranceAndProtectionInformationPage from './frontend/pages/LifeInsuranceAndProtectionInformation';
import HomeInsurancePage from './frontend/pages/HomeInsurance';
import LandlordInsurancePage from "./frontend/pages/LandlordInsurance";
import MortgageCalculatorPage from "./frontend/pages/Calculators";
import TestimonialsPage from './frontend/pages/Testimonials';
import PrivacyPolicyPage from './frontend/pages/PrivacyPolicy';
import BlogsPage from './frontend/pages/Blogs';
import OurTeamPage from './frontend/pages/OurTeam';
import ClientPortalPage from './frontend/pages/ClientPortal';
import CalculatorsPage from './frontend/pages/Calculators';
import MortgageBorrowCalculatorsPage from './frontend/calculators/MortgageBorrowPage';
import MortgageRepaymentCalculatorsPage from './frontend/calculators/MortgageRepaymentPage';
import OverpaymentCalculatorsPage from './frontend/calculators/OverpaymentPage';
import StampDutyCalculatorsPage from './frontend/calculators/StampDutyPage';
import HowMuchWillItCostCalculatorsPage from './frontend/calculators/HowMuchWillItCostPage';
import HowMuchCanIBorrowCalculatorsPage from './frontend/calculators/HowMuchCanIBorrowPage';
import EquityReleaseCalculatorsPage from './frontend/calculators/EquityReleasePage';
import RelevantLifeTaxCalculatorsPage from './frontend/calculators/RelevantLifeTaxPage';
import MortgageAdviceForTeachersPage from './frontend/pages/MortgageAdviceForTeachersPage';

import Blog1 from './frontend/pages/Blogs/Blog1';
import Blog2 from './frontend/pages/Blogs/Blog2';
import Blog3 from './frontend/pages/Blogs/Blog3';
import Blog4 from './frontend/pages/Blogs/Blog4';
import Blog5 from './frontend/pages/Blogs/Blog5';
import Blog6 from './frontend/pages/Blogs/Blog6';
import Blog7 from './frontend/pages/Blogs/Blog7';
import Blog8 from './frontend/pages/Blogs/Blog8';
import Blog9 from './frontend/pages/Blogs/Blog9';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/mortgages" element={<MortgagePage />} />
          <Route
            path="/business-protection"
            element={<BusinessProtectionPage />}
          />
          <Route
            path="/relevant-life-plan"
            element={<RelevantLifePlanPage />}
          />
          <Route
            path="/life-insurance"
            element={<LifeInsuranceAndProtectionInformationPage />}
          />
          <Route path="/home-insurance" element={<HomeInsurancePage />} />
          <Route
            path="/landlord-insurance"
            element={<LandlordInsurancePage />}
          />
          <Route path="/calculators" element={<CalculatorsPage />} />
          <Route path="/mortgage-advice-for-teachers" element={<MortgageAdviceForTeachersPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/blogs" element={<BlogsPage />} />
          <Route path="/our-team" element={<OurTeamPage />} />
          <Route path="*" element={<HomePage />} />
          <Route path="/client-portal" element={<ClientPortalPage />} />
          <Route
            path="/mortgage-borrow"
            element={<MortgageBorrowCalculatorsPage />}
          />
          <Route
            path="/mortgage-repayment"
            element={<MortgageRepaymentCalculatorsPage />}
          />
          <Route
            path="/mortgage-advice-for-teachers"
            element={<MortgageAdviceForTeachersPage />}
          />
          <Route path="/overpayment" element={<OverpaymentCalculatorsPage />} />
          <Route path="/stamp-duty" element={<StampDutyCalculatorsPage />} />
          <Route
            path="/how-much-will-it-cost"
            element={<HowMuchWillItCostCalculatorsPage />}
          />
          <Route
            path="/how-much-can-i-borrow"
            element={<HowMuchCanIBorrowCalculatorsPage />}
          />
          <Route
            path="/equity-release"
            element={<EquityReleaseCalculatorsPage />}
          />
          <Route
            path="/relevant-life-tax"
            element={<RelevantLifeTaxCalculatorsPage />}
          />
          <Route path="/blogs1" element={<Blog1 />} />
          <Route path="/blogs2" element={<Blog2 />} />
          <Route path="/blogs3" element={<Blog3 />} />
          <Route path="/blogs4" element={<Blog4 />} />
          <Route path="/blogs5" element={<Blog5 />} />
          <Route path="/blogs6" element={<Blog6 />} />
          <Route path="/blogs7" element={<Blog7 />} />
          <Route path="/blogs8" element={<Blog8 />} />
          <Route path="/blogs9" element={<Blog9 />} />
        </Routes>
      </div>
      <ContactUs />
      <Footer />
    </Router>
  );
}

export default App;
